import { render, staticRenderFns } from "./AddCafeteriaPage.vue?vue&type=template&id=24c6e063"
import script from "./AddCafeteriaPage.vue?vue&type=script&lang=js"
export * from "./AddCafeteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports